import {Model as OrmModel} from "@vuex-orm/core";


export class Model extends OrmModel
{
  // static async insertMany(items) {
  //   for (let index = 0; index < items.length; index++) {
  //     await this.insertOrUpdate({data: items[index]})
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/store/models/model.js